// trusted-by-thousands Start

$(document).ready(function(){
    $('.trusted-by-thousands .testimonial-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 39 40" fill="none"><path d="M30.7 19.9993L8.53061 19.9993M15.9357 27.9993L8.30005 19.9993L15.9357 11.9993" stroke="#153B36" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 39 40" fill="none"><path d="M8.29995 19.9993L30.4694 19.9993M23.0643 27.9993L30.7 19.9993L23.0643 11.9993" stroke="#153B36" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3
          }
        },
        {
        breakpoint: 900,
        settings: {
            slidesToShow: 2,
            dots: false
          }
        },
        {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
});
// trusted-by-thousands END
